import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom/client";

import "@fontsource/cinzel/600.css";
import "@fontsource/cinzel/700.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

import App from "./components/app";
import { darkTheme, lightTheme } from "./theme/mtgTheme";
import { ThemeModeContext } from "./theme/theme-mode.context";

const THEME_MODE_STORAGE_KEY = "mtg-deck-builder.theme-mode";

const WebsiteRoot = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const storedThemeMode = window.localStorage.getItem(THEME_MODE_STORAGE_KEY);

    if (storedThemeMode === "light") {
      return false;
    }

    return true;
  });
  const theme = useMemo(
    () => (isDarkMode ? darkTheme : lightTheme),
    [isDarkMode],
  );
  const themeModeContextValue = useMemo(
    () => ({
      isDarkMode,
      toggleThemeMode: () => {
        setIsDarkMode((currentMode) => !currentMode);
      },
    }),
    [isDarkMode],
  );

  useEffect(() => {
    window.localStorage.setItem(
      THEME_MODE_STORAGE_KEY,
      isDarkMode ? "dark" : "light",
    );
  }, [isDarkMode]);

  return (
    <ThemeModeContext.Provider value={themeModeContextValue}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// NOTE: StrictMode causes 2 renders in order to detect any problems with the code and warn about them
// NOTE: StrictMode does not cause multiple renders in the production build
root.render(
  <React.StrictMode>
    <WebsiteRoot />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
